import UsersList from "../component/UsersList";
import React from "react";

const UsersListContainer = ({ pageId }) => (<UsersList pageId={ pageId } />)

export default UsersListContainer;